import {GetHealthDatesParams} from 'domain/usecases';
import {makeGetHealthDates as makeGetHealthDatesV1} from 'main/factories/usecases/private/booking-flow/remote-health-booking-v1';
import {makeGetHealthDates} from 'main/factories/usecases';
import {sortDateStringArray} from 'presentation/utils';
import {GetHealthDatesParams as GetHealthDatesParamsV1} from 'domain/usecases/private/booking-flow/health-V1';

async function getHealthDates(params: GetHealthDatesParams) {
	const dates = await makeGetHealthDates().get(params);

	if (!dates) return [];

	return sortDateStringArray(dates.content);
}

async function getHealthDatesV1(params: GetHealthDatesParamsV1) {
	const dates = await makeGetHealthDatesV1().get(params);

	if (!dates) return [];

	return sortDateStringArray(dates);
}

export {getHealthDates, getHealthDatesV1};
